import React from 'react';
import {
  AutoCompleteSelectUI,
  ButtonUI,
  CheckboxUI,
  DebouncedInputUI,
  FormLabelUI,
  StaticDatePickerUI,
} from '../../../Interface';
import dayjs from 'dayjs';
import { e } from 'mathjs';

const CalendarFilter = ({ filter, dates, autocompleteOptions, setCalendarEventDialogOpen }) => {
  const { filterVal, setFilterVal } = filter;
  const { date, setDate } = dates;
  return (
    <div>
      <div className="w-full">
        <StaticDatePickerUI
          sx={{
            '& .MuiDatePickerToolbar-root': {
              display: 'none',
            },
            '& .MuiDialogActions-root': {
              display: 'none',
            },
            ' & .MuiDateCalendar-root': {
              background: '#f3f4f6',
            },
          }}
          value={dayjs(date)}
          onChange={(newDate) => {
            setDate((prevState) => ({
              ...prevState,
              startDate: newDate ? newDate.startOf('day') : null,
              endDate: newDate ? newDate.endOf('day') : null,
            }));
          }}
        />
      </div>
      <div className="px-2">
        <DebouncedInputUI
          size="small"
          label={<FormLabelUI text="Projekt keresése" />}
          debounceMs={800}
          setQuickFilterSearchValue={(newValue) => {
            setFilterVal((prev) => ({
              ...prev,
              projectName: newValue,
            }));
          }}
          quickFilterSearchValue={filterVal.projectName}
        />
        <div className="mt-5">
          <p className="text-xl text-labelColor">Személyek</p>
          <AutoCompleteSelectUI
            selectedValue={filterVal.resourceOneId}
            label={<FormLabelUI text="Személyek keresése" />}
            onChange={(_event, newVal, _reason) => {
              setFilterVal((prev) => ({
                ...prev,
                resourceOneId: newVal,
              }));
            }}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            multiple
            freeSolo
            dataset={autocompleteOptions.resourceOne}
          />
        </div>
        <div className="mt-5">
          <p className="text-xl text-labelColor mb-3">Egyéb</p>
          <ButtonUI
            size="sm"
            className="bg-warning"
            text="Új esemény"
            onClick={() => setCalendarEventDialogOpen(true)}
          />
          <CheckboxUI
            label="Kiosztott feladatok mutatása"
            checked={filterVal.openedTasks}
            onChange={(e) =>
              setFilterVal((prev) => ({
                ...prev,
                openedTasks: !filterVal.openedTasks,
              }))
            }
          />
        </div>
      </div>
    </div>
  );
};

export default CalendarFilter;
